<template>
	<div>
		<el-card>
			<div slot="header" style="display: inline-block;float: left;font-weight: bolder;font-size: 24px;">远程设备管理</div>
			<el-button type="primary" slot="header" @click="back">返回门禁设备管理</el-button>
			<el-button type="primary" slot="header" @click="add">添加远程门禁设备</el-button>
			<!-- 子门禁表格 -->
			<el-table :data="list" class="wid100" :height="list.length > 0 ? 529 : 109">
				<el-table-column type="index" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
				<el-table-column prop="ycDeviceName" label="远程设备地址"></el-table-column>
				<el-table-column prop="ycDoorId" label="远程门Id"></el-table-column>
				<el-table-column prop="ycDoorInfo" label="远程门名称"></el-table-column>
				<el-table-column prop="createTime" :label="$t('lang.lab_ctDoorDeviceSon')">
					<template slot-scope="scope">
						{{scope.row.createTime | time}}
					</template>
				</el-table-column>
				<el-table-column prop="operTime" :label="$t('lang.lab_otDoorDeviceSon')">
					<template slot-scope="scope">
						{{scope.row.operTime | time}}
					</template>
				</el-table-column>
				<el-table-column prop="operation" :label="$t('lang.lab_operation')" width="150px">
					<template slot-scope="scope">
						<!-- <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button> -->
						<el-button class="orange" @click="del(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-card>

		<!-- 添加子门禁dialog -->
		<el-dialog title="添加远程设备" :visible.sync="addDialogFormVisible" :close-on-click-modal="false"
			center top="130px" width="600px">
			<el-form :model="doorDeviceSonForm" :rules="rules" ref="doorDeviceSonForm">
				<el-form-item label="远程设备地址" label-width="120px" prop="ycDeviceName">
					<el-input v-model="doorDeviceSonForm.ycDeviceName" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="远程门Id" label-width="120px" prop="ycDoorId">
					<el-input v-model="doorDeviceSonForm.ycDoorId" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="远程门名称" label-width="120px" prop="ycDoorInfo">
					<el-input v-model="doorDeviceSonForm.ycDoorInfo" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="推送模式" label-width="120px" prop="pushType">
					<el-radio-group v-model="doorDeviceSonForm.pushType">
						<el-radio :label="1">阿里云</el-radio>
						<el-radio :label="2">MQTT</el-radio>
					</el-radio-group>
				</el-form-item>				
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addDialogFormVisible = false">{{$t('lang.btn_cancel')}}</el-button>
				<el-button type="primary" @click="addDoorDeviceSon(doorDeviceSonForm)">{{$t('lang.btn_save')}}</el-button>
			</div>
		</el-dialog>
		<!-- 修改子门禁dialog -->
		<el-dialog :title="$t('lang.lab_editDoorDeviceSon')" :visible.sync="editDialogFormVisible" :close-on-click-modal="false"
			center top="130px" width="600px">
			<el-form :model="doorDeviceSonForm" :rules="rules" ref="doorDeviceSonForm">
				<el-form-item :label="$t('lang.lab_numDoorDeviceSon')" label-width="120px" prop="xlDeviceNum">
					<el-input v-model="doorDeviceSonForm.xlDeviceNum" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_nameDoorDeviceSon')" label-width="120px" prop="xlDeviceName">
					<el-input v-model="doorDeviceSonForm.xlDeviceName" autocomplete="off"></el-input>
				</el-form-item>
				
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="editDialogFormVisible = false">{{$t('lang.btn_cancel')}}</el-button>
				<el-button type="primary" @click="editDoorDeviceSon(doorDeviceSonForm)">{{$t('lang.btn_save')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				doorDeviceId: '',
				list: [],

				addDialogFormVisible: false,
				doorDeviceSonForm: {
					id: '',
					ycDeviceName: '',
					ycDoorId: '',
					pushType: 2,
					ycDoorInfo: ''
				},

				editDialogFormVisible: false,

				rules: {
					ycDeviceName: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input'),
						trigger: 'blur'
					}],
					ycDoorId: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input'),
						trigger: 'blur'
					}],
					ycDoorInfo: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input'),
						trigger: 'blur'
					}],
					pushType: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input'),
						trigger: 'blur'
					}],
				}
			}
		},
		created() {
			this.doorDeviceId = this.$route.query.id
			this.selectList()
		},
		methods: {
			back() {
				this.$router.push({
          name: 'accessControlEquipmentManagementList'
        })
			},
			selectList() {
				let loading = this.$loading()
				this.$get(`ycDevice/?deviceId=` + this.doorDeviceId + `&pageNo=1&pageSize=99`)
					.then(response => {
						// console.log(response);
						this.list = response.list
						loading.close()
					})
					.catch(error => {
						console.log(error)
					})
			},
			add() {
				this.addDialogFormVisible = true
				this.doorDeviceSonForm.ycDeviceName = ''
				this.doorDeviceSonForm.ycDoorId = ''
				this.doorDeviceSonForm.pushType = 2
				this.doorDeviceSonForm.ycDoorInfo = ''
			},
			addDoorDeviceSon(doorDeviceSonForm) {
				this.$refs.doorDeviceSonForm.validate((valid) => {
					if (valid) {
						let loading = this.$loading()
						let param = {
							deviceId: this.doorDeviceId,
							ycDeviceName: doorDeviceSonForm.ycDeviceName,
							ycDoorId: doorDeviceSonForm.ycDoorId,
							pushType: doorDeviceSonForm.pushType,
							ycDoorInfo: doorDeviceSonForm.ycDoorInfo
						}
						this.$post(`/ycDevice`, param)
							.then(response => {
								// console.log(response);
								this.$message.success(this.$i18n.t('lang.lab_save_success'))
								this.selectList()
								this.addDialogFormVisible = false
								loading.close()
							})
							.catch(error => {
								console.log(error)
								loading.close()
								this.$message.error(this.$i18n.t('lang.resourAddLose'))
							})
					} else {
						// console.log('error submit!!')
						return false
					}
				})
			},
			edit(row) {
				this.editDialogFormVisible = true
				this.doorDeviceSonForm.id = row.id
				this.doorDeviceSonForm.xlDeviceName = row.xlDeviceName
				this.doorDeviceSonForm.xlDeviceNum = row.xlDeviceNum
				// console.log(row)
			},
			editDoorDeviceSon(doorDeviceSonForm) {
				this.$refs.doorDeviceSonForm.validate((valid) => {
					if (valid) {
						let loading = this.$loading()
						let param = {
							deviceId: this.doorDeviceId,
							xlDeviceName: doorDeviceSonForm.xlDeviceName,
							xlDeviceNum: doorDeviceSonForm.xlDeviceNum
						}
						this.$patch(`/xlDevice/` + this.doorDeviceSonForm.id, param)
							.then(response => {
								this.$message.success(this.$i18n.t('lang.lab_save_success'))
								this.selectList()
								this.editDialogFormVisible = false
								loading.close()
							})
							.catch(error => {
								console.log(error)
								this.$message.error(this.$i18n.t('lang.resourEditLose'))
								loading.close()
							})
					} else {
						// console.log('error submit!!')
						return false
					}
				})
			},
			del(id) {
				let loading = this.$loading()
				this.$delete(`/ycDevice/` + id)
					.then(response => {
						if (response && response.errCode === 0) {
							this.$message({
								type: 'success',
								message: this.$i18n.t('lang.lab_del_success')
							})
							this.selectList()
							loading.close()
						}
					})
					.catch(error => {
						this.$message({
							type: 'error',
							message: this.$i18n.t('lang.lab_del_fail')
						})
						loading.close()
						console.log(error)
					})
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>
